/**
 * Checkout coupon across the Google/Facebook sign-in round-trip on /setup.
 *
 * The OAuth callback always returns to `/setup?step=1&fromOAuth=true` (no query carried over),
 * and the setup flow reads the coupon from `?coupon=`. SetupPage.handleOAuth saves the coupon
 * into the same localStorage setup state (`outfame-setup-state`) that already carries
 * username/platform/profile/period across the redirect; useSetupFlow puts it back on the URL
 * when the flow rebuilds, so the buyer keeps the discount and the partner keeps attribution.
 */

/** Coupon saved in the OAuth setup state, or null when none / malformed state. */
export function savedSetupCoupon(savedState: unknown): string | null {
    if (!savedState || typeof savedState !== "object") return null
    const coupon = (savedState as { coupon?: unknown }).coupon
    return typeof coupon === "string" && coupon.length > 0 ? coupon : null
}

/**
 * Query string with the saved coupon restored, or null when nothing changes
 * (no saved coupon, or the URL already carries a coupon — the URL always wins).
 */
export function queryWithRestoredCoupon(query: string, coupon: string | null): string | null {
    if (!coupon) return null
    const params = new URLSearchParams(query)
    if (params.get("coupon")) return null
    params.set("coupon", coupon)
    return params.toString()
}
